import { WebhookLog, WebhookLogElasticsearchHit } from '../types';

const toDate = (value?: string): Date | undefined => {
    if (!value) return undefined;
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return undefined;
    return date;
};

const formatWebhookLogFromElasticsearch = (
    hit: WebhookLogElasticsearchHit,
): WebhookLog => {
    const createdAt = toDate(hit.createdAt) || toDate(hit['@timestamp']) || new Date(0);

    return {
        id: hit.id,
        endpoint: hit.request?.url || '',
        createdAt,
        updatedAt: toDate(hit.updatedAt),
        request: hit.request,
        response: hit.response,
        status: hit.status,
        durationMs: hit.durationMs,
    };
};

export default formatWebhookLogFromElasticsearch;
